import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgArrowClockwise = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.25 6.125v5.25a.875.875 0 0 1-.875.875h-5.25a.875.875 0 0 1 0-1.75h2.997l-2.908-2.664-.028-.027a8.75 8.75 0 1 0-.182 12.554.876.876 0 0 1 1.203 1.273A10.439 10.439 0 0 1 14 24.5h-.144A10.501 10.501 0 0 1 7.37 5.858a10.5 10.5 0 0 1 14.04.704l3.09 2.822V6.125a.875.875 0 0 1 1.75 0Z" />
  </svg>
);
export default SvgArrowClockwise;
